<i18n>
{
    "en": {
        "Day": "Day",
		"Month": "Month",
		"Ordinarily": "Ordinarily",
        "DayRepeatMonthly": "Day repeat monthly",
        "TimeRepeatMonthly": "Time repeat monthly"
    },
    "vi": {
        "Day": "Ngày",
		"Month": "Tháng",
		"Ordinarily": "Thứ tự",
        "DayRepeatMonthly": "Vào ngày",
        "TimeRepeatMonthly": "Vào thời điểm"
    }
}
</i18n>

<template>
	<div class="monthly-config-repeat">
		<div class="flex items-baseline flex-wrap sm:flex-no-wrap mb-3">
			<vs-radio class="mb-3 sm:mb-0 sm:mr-3" vs-name="monthly-config" v-model="configMode" :vs-value="configModeOptions.dayOfMonth">
				<span>{{ $t("DayRepeatMonthly") }}</span>
			</vs-radio>
			<div class="p-1 pl-10">
				<cbs-select-number
					name="dayRepeatMonthly"
					filterable
					dataType="int"
					class="block w-auto"
					v-validate="configMode === 0 ? 'required' : ''"
					v-model="day"
					:data-vv-as="$t('Day')"
					:placeholder="`${$t('Actions.Choose')} ${$t('Day').toLowerCase()}`"
				/>
				<span class="text-danger text-sm break-normal" v-show="errors.has('dayRepeatMonthly')">{{ errors.first("dayRepeatMonthly") }}</span>
			</div>
		</div>
		<div class="flex items-baseline flex-wrap sm:flex-no-wrap mb-3">
			<vs-radio class="" vs-name="monthly-config" v-model="configMode" :vs-value="configModeOptions.timeOfTheMonth">
				<span class="whitespace-no-wrap">{{ $t("TimeRepeatMonthly") }}</span>
			</vs-radio>
			<select-ordinarily-day
				v-model="localValue[configModeOptions.timeOfTheMonth]"
				class="p-1 pl-5 rounded"
				:dayLabel="$t('Day')"
				:ordinarilyLabel="$t('Ordinarily')"
				:dayPlaceholder="`${$t('Actions.Choose')} ${$t('Day').toLowerCase()}`"
				:ordinarilyPlaceholder="`${$t('Actions.Choose')} ${$t('Ordinarily').toLowerCase()}`"
				:required="configMode === 1 ? 'required' : ''"
			/>
		</div>
	</div>
</template>

<script>
import SelectOrdinarilyDay from "./SelectOrdinarilyDay";
import CbsSelectNumber from "@/components/cbs-select-number/CbsSelectNumber";

export default {
	name: "MonthlyConfigRepeat",
	inject: ["parentValidator"],
	components: {
		CbsSelectNumber,
		SelectOrdinarilyDay
	},
	props: {
		value: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			localValue: {},
			configMode: 0,
			configModeOptions: {
				dayOfMonth: 0,
				timeOfTheMonth: 1
			},
			day: null
		};
	},
	watch: {
		sortedValue() {
			if (JSON.stringify(this.sortedValue) !== JSON.stringify(this.localValue[this.configMode])) {
				this.setInitData();
			}
		},
		localValue: {
			handler: function() {
				this.setNextValue();
			},
			deep: true
		},
		configMode() {
			this.setNextValue();
		},
		day() {
			this.localValue[this.configModeOptions.dayOfMonth].bymonthday = this.day;
		}
	},
	computed: {
		sortedValue() {
			return {
				byday: this.value.byday,
				bysetpos: this.value.bysetpos,
				bymonthday: this.value.bymonthday
			};
		}
	},
	methods: {
		setInitData() {
			if (this.sortedValue.bysetpos && this.sortedValue.byday) {
				this.configMode = this.configModeOptions.timeOfTheMonth;
			} else {
				this.configMode = this.configModeOptions.dayOfMonth;
			}
			this.localValue = {
				[this.configModeOptions.dayOfMonth]: {
					byday: null,
					bysetpos: null,
					bymonthday: this.sortedValue.bymonthday
				},
				[this.configModeOptions.timeOfTheMonth]: {
					byday: this.sortedValue.byday,
					bysetpos: this.sortedValue.bysetpos,
					bymonthday: null
				}
			};
			this.day = this.localValue[this.configModeOptions.dayOfMonth].bymonthday;
		},
		setNextValue() {
			if (JSON.stringify(this.sortedValue) !== JSON.stringify(this.localValue[this.configMode])) {
				let nextValue = {};
				if (this.configMode === this.configModeOptions.dayOfMonth) {
					nextValue = { ...this.localValue[this.configModeOptions.dayOfMonth], byday: null, bysetpos: null };
				}
				if (this.configMode === this.configModeOptions.timeOfTheMonth) {
					nextValue = { ...this.localValue[this.configModeOptions.timeOfTheMonth], bymonthday: null };
				}
				this.$emit("input", nextValue);
			}
		}
	},
	created() {
		if (this.parentValidator) {
			this.$validator = this.parentValidator;
		}
		this.setInitData();
	}
};
</script>
